<template>
  <v-toolbar height="48px" style="width: 100%; position: fixed; z-index: 10">
    <v-app-bar-nav-icon class="d-inline d-lg-none" @click="mini = !mini"></v-app-bar-nav-icon>
    <v-toolbar-title class="d-none d-md-inline mr-4"><span class="back" style="color: #3A3852; font-size: inherit; font-weight: 800">Back</span><span class="office" style="font-size: inherit; font-weight: 800">Office</span></v-toolbar-title>
    <div class="d-inline-block">
      <template v-for="group in cardGroups">
        <v-menu bottom offset-y v-if="entity[group.getter].length > 1">
          <template v-slot:activator="{ on, attrs }">
            <v-badge v-if="entity[group.getter].length > 1"
                :content="entity[group.getter].length"
                :value="entity[group.getter].length"
                left
                color="secondary"
                overlap
            >
              <v-btn outlined color="primary lighten-1" v-bind="attrs" v-on="on" class="mr-2">
                  <v-icon class="mr-2">{{group.icon}}</v-icon>
                  <v-icon small>mdi-menu-down</v-icon>
              </v-btn>
            </v-badge>
          </template>
          <v-list v-if="entity[group.getter].length > 1">
            <v-list-item v-for="card in entity[group.getter]" :key="`toolbar-${card.key}`">
              <v-list-item-title>
                <a @click="maximizeCard(card.key)">{{ card.title }}</a>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-else-if="entity[group.getter].length === 1"
               outlined
               color="primary lighten-1"
               class="mr-2"
               @click="maximizeCard(entity[group.getter][0].key)">
          <v-icon class="mr-2">{{group.icon}}</v-icon>
          <v-subheader class="ma-0 pa-0">{{entity[group.getter][0].title}}</v-subheader>
        </v-btn>
      </template>
    </div>
    <v-spacer></v-spacer>

      <div class="notification-icon">
        <v-btn v-if="chatWhiteListUsers()" @click="showChat" icon class="chat-icon-button">
          <i class="fas fa-comment-dots fa-lg" style="color: #5c6bc0;"></i>
          <span v-if="this.getNewMessageCount()" class="new-message-count">{{ this.getNewMessageCount() }}</span>
        </v-btn>
        <b-button variant="light" class="btn-icon" id="popover-notification" href="#" tabindex="0">
          <i class="icon-notification far fa-bell"></i>
          <div class="badge-block" v-if="getNotifications.length > 0">
            <b-badge variant="primary" class="number">{{ getNotifications.filter(i=>(i.status==='unseen')).length }}</b-badge>
          </div>
        </b-button>

        <b-popover class="notifications" target="popover-notification" triggers="focus" placement="bottom">
          <template v-slot:title>Notifications</template>
          <b-badge :variant="badgeColors[0]" @click="filterDate('today')">Today</b-badge>
          <b-badge :variant="badgeColors[1]" @click="filterDate('yesterday')">Yesterday</b-badge>
          <b-badge :variant="badgeColors[2]" @click="filterDate('allPeriod')">All Period</b-badge>
          <a @click="markAllAsRead" class="mark-read" href="" :disabled="!getNotifications || getNotifications.length === 0">Mark all as read</a>
          <div class="notification-list" v-if="!getNotifications || getNotifications.length === 0">
            <p class="note">No new notifications.</p>
          </div>
          <div v-else :class="{ 'notification-list': true, 'extended-block': isNotificationExtended }">
            <div v-show="!isNotificationExtended" v-for="notification in getNotifications.slice(0, 5)">
              <div class="notification-block" @click="showCard(notification)">
                <div class="status-dot"  :class="{ 'seen': notification.status  === 'seen', 'unseen':  notification.status  === 'unseen' }"></div>
                <p class="note" >{{ notification.note }} ( {{ notification.affiliateName }} {{ notification.id }} ) </p>
                <p class="time">{{ formatDate(notification.dateAdded) }}</p>
              </div>
            </div>

            <div v-show="isNotificationExtended" v-for="notification in getNotifications">
              <div class="notification-block" @click="showCard(notification)">
                <div class="status-dot"  :class="{ 'seen': notification.status  === 'seen', 'unseen':  notification.status  === 'unseen' }"></div>
                <p class="note" >{{ notification.note }} ({{ notification.affiliateName }} {{ notification.id }} ) </p>
                <p class="time">{{ formatDate(notification.dateAdded) }}</p>
              </div>
            </div>
          </div>
          <b-button @click="isNotificationExtended = !isNotificationExtended" variant="primary" class="btn-viewmore">
            {{isNotificationExtended ? 'View less' : 'View more'}}
          </b-button>
        </b-popover>
      </div>

    <v-menu
        :close-on-content-click="false"
        :nudge-width="200"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            text
            large
            v-bind="attrs"
            v-on="on"
            class="text-capitalize px-0"
        >
          <img class="user-avatar" :src="getUrlAvatar()" />
          <span class="d-none d-md-inline username">{{getUserName()}}</span>
          <v-icon small>mdi-menu-down</v-icon>
          <!-- <i class="fal fa-angle-down"></i> -->
        </v-btn>
      </template>

      <v-card class="text-right">
        <div class="pa-4 pb-0">
          You are currently signed in as<br>
          <strong>{{getUserEmail()}}</strong><br>({{ getUserRole() }})
        </div>
        <v-list>
          <v-divider class="my-2"></v-divider>
          <v-list-item v-if="isManager()" @click="copyLink">
            <v-list-item-title>Copy Signup Link
              <v-icon>mdi-content-copy</v-icon>
            </v-list-item-title>
            <div class="loader-wrapper" v-if="loading">
              <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
          </v-list-item>
          <v-divider class="my-2" v-if="isManager()"></v-divider>
          <v-list-item @click="loginOut">
            <v-list-item-title>Sign out <v-icon>mdi-logout</v-icon></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <div class="d-none d-md-block role">{{ getUserRole() }}</div>
    <v-menu
        :close-on-content-click="false"
        :nudge-width="200"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon
               v-bind="attrs"
               v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-subheader>Themes</v-subheader>
        <v-list-item-group
            v-model="selectedWorkspace"
            color="primary"
            @change="changeWorkspace"
        >
          <v-list-item v-for="(item) in workspaces"
                       :key="`theme-${item.value}`" :value="item.value">
            <v-list-item-title><v-chip small class="mr-2" :color="item.color"></v-chip>{{item.text}}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import store from "@/store";
import {deleteCookie} from "@/helpers";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import theme from "@/plugins/vuetify/theme";

export default {
  name: "Header",
  data() {
    return {
      badgeColors: ["primary", "light", "light"],
      isNotificationExtended: false,
      entity: this,
      workspaces: [
        {value: 'blue', text: 'Blue', color: theme['blue'].primary},
        {value: 'orange', text: 'Orange', color: theme['orange'].primary},
        {value: 'teal', text: 'Teal', color: theme['teal'].primary}
      ],
      selectedWorkspace: localStorage.getItem('workspace') || 'blue',
      showDropdown: false,
      drawer: false,
      mini: true,
      managerId: null,
      cardGroups: [
          {type: 'offer', icon: 'fa-hand-holding-usd', getter: 'offerCards'},
          {type: 'advertiser', icon: 'fal fa-ad', getter: 'advertiserCards'},
          {type: 'campaign', icon: 'fal fa-bullhorn', getter: 'campaignCards'},
          {type: 'affiliate', icon: 'fal fa-user-friends', getter: 'affiliateCards'},
          {type: 'offerAggregatedLPCard', icon: 'fal fa-user-friends', getter: 'offerAggregatedLPCard'},
          {type: 'lid', icon: 'fal fa-user-friends', getter: 'lidCard'},
          {type: 'chat', icon: 'fal fa-comment-dots', getter: 'chatCards'},
          {type: 'chatMessages', icon: 'fal fa-comments', getter: 'chatMessagesCards'},
      ],
      loading: false,
    }
  },
  watch: {
    async mini() {
      this.$emit('input', this.mini);
    },
  },
 	async mounted() {
    await store.dispatch('notifications/getNotifications',{
      employeeId: this.user[0].employee_id,
      email: this.user[0].email
    })
    const affiliateManager = this.affiliateManagers.find(item => item.email === this.user[0].email);
    console.log(`affiliateManager ${JSON.stringify(affiliateManager)}`)
    if (affiliateManager){
      this.managerId = affiliateManager.id;
      await this.SUBSCRIBE_USER_TO_MESSAGES(this.managerId);
      await store.dispatch('messages/FETCH_MESSAGES');
      window.addEventListener('beforeunload', this.handleBeforeUnload);
    }


    // if (this.user[0].email === 'dmytro.miroshnykov@actionmediamtl.com'){
    //   console.log(`env debug  ${JSON.stringify(process.env)}`);
    // }

  },
  beforeDestroy() {
    if (this.managerId){
      this.UNSUBSCRIBE_USER_FROM_MESSAGES();
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

  },
  methods: {
    ...mapMutations('messages', ['setNewThreadMessages','setSelectedThread']),
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
    ...mapActions('messages', ['SUBSCRIBE_USER_TO_MESSAGES','UNSUBSCRIBE_USER_FROM_MESSAGES','FETCH_THREAD_MESSAGES']),
    handleBeforeUnload() {
      this.UNSUBSCRIBE_USER_FROM_MESSAGES();
    },
    getNewMessageCount() {
      let totalCount = 0;
      const messageUnread = this.getThreadMessages.filter(item => item.status === 'unread')
      messageUnread.forEach(item => {
          totalCount += item.countOfUnreadMessages;
      });
      return totalCount + this.getNewThreadMessages.length;
    },
    chatWhiteListUsers() {
      const userRole = this.user.length > 0 && this.user[0].role
      const whiteList = [
        'QA',
        'Admin'
      ];
      return whiteList.includes(userRole) && this.managerId;
    },
    async maximizeCard(key) {
      const isChatMessageCard = key.includes('chatMessages');
      if (isChatMessageCard){
        const currentCard = this.getCards.find((card) => card.key === key);
        currentCard.data.thread_id = currentCard.data.id;
        this.setSelectedThread({ ...currentCard.data });
        await this.FETCH_THREAD_MESSAGES()
        const item = this.getSelectedThread;
        await store.dispatch('cards/REMOVE', key)
        await store.dispatch('cards/ADD', {
          type: 'chatMessages',
          title: `${item.affiliate_name}`,
          key: key,
          data: item,
          customSize: {
            width: 717,
            height: 824,
            top: 45,
            left: 765,
          },
        })

      } else {
        await store.dispatch('cards/MAXIMIZE', key);
      }

    },
    showCard(item) {
      store.dispatch('cards/ADD', {
        type: 'affiliate',
        title: item.id,
        tab: 7, // 7 - notes
        key: `affiliate-${item.id}`,
        data: {...item }
      })

      if ( item.status === 'unseen' ) {
        item.status = 'seen'
        store.dispatch('notifications/updateNotification', item)
      }
    },
    showChat() {
      store.dispatch('cards/ADD', {
        type: 'chat',
        title: 'Contacts',
        key: `chat`,
        customSize: {
          width: 713,
          height: 824,
          top: 45,
          left: 53,
        },
      })
    },
    filterDate(dateRange){
      store.dispatch('notifications/getNotifications',{
        employeeId: this.user[0].employee_id ,
        email: this.user[0].email,
        dateRange
      })
      this.badgeColors.fill("light");
      switch (dateRange) {
        case "today" :
          this.badgeColors[0] = "primary";
          break;
        case "yesterday":
          this.badgeColors[1] = "primary";
          break;
        case "allPeriod":
          this.badgeColors[2] = "primary";
          break;
      }
    },
    formatDate(strDate){
      const date = new Date(strDate);
      const today = new Date();
      const diffTime = Math.abs(today - date);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays === 1) {
        return "Yesterday";
      } else if (diffDays <= 7) {
        return `${diffDays} days ago`;
      } else {
        return date.toLocaleDateString();
      }
    },
    changeWorkspace(event) {
      localStorage.setItem('workspace', this.selectedWorkspace)
      this.$vuetify.theme.themes.light = theme[this.selectedWorkspace];
    },
    getUrlAvatar() {
      return this.user.length > 0 && this.user[0].picture
    },
    getUserEmail() {
      return this.user.length > 0 && this.user[0].email
    },
    getUserName() {
      return this.user.length > 0 && this.user[0].name
    },
    getUserRole() {
      return this.user.length > 0 && this.user[0].role
    },
    markAllAsRead(event) {
      event.preventDefault()
      this.getNotifications.filter(item => item.status === 'unseen').forEach(item => {
        item.status = 'seen'
        store.dispatch('notifications/updateNotification',item)
      })
    },
    loginOut() {
      deleteCookie('accessToken')
      this.$router.push('/login')
      location.reload()
    },
    async copyLink() {
      if (!this.signupLink) {
        this.loading = true;
        try {
          await store.dispatch('managers/getSignupLink', {
            employeeId: this.user[0].employee_id
          })
        } catch (err) {
          this.ALERT_ERROR(err.message);
          this.loading = false;
          return false
        }
        this.loading = false;
      }
      await navigator.clipboard.writeText(this.signupLink)
      this.ALERT_SUCCESS('Signup Link Copied');
      setTimeout(() => {
        this.ALERT_SUCCESS('');
      }, 3500)
    },
    isManager() {
      return this.user[0].permissions.includes('see_affiliates_section')
    }
  },
  computed : {
    ...mapState('user', ['user']),
    ...mapGetters('cards', [
      'offerCards',
      'advertiserCards',
      'campaignCards',
      'affiliateCards',
      'offerAggregatedLPCard',
      'lidCard',
      'chatCards',
      'chatMessagesCards',
      'getCards'
    ]),
    ...mapState('managers', ['affiliateManagers']),
    ...mapGetters(
        'managers', ['signupLink']
    ),
    ...mapGetters(
        'messages', ['getNewThreadMessages','getThreadMessages','getSelectedThread']
    ),
    ...mapGetters(
        'notifications', ['getNotifications']
    )
  },
  created() {
    if (this.user[0]) {
      if (!['blue', 'orange', 'teal'].includes(localStorage.getItem('workspace'))) {
        switch(window.location.hostname) {
          case 'backoffice.aezai.com': 
            this.selectedWorkspace = 'teal';
            break;
          case 'backoffice.kprnt.com': 
            this.selectedWorkspace = 'orange';
            break;
          default: 
            this.selectedWorkspace = 'blue';
            break;
        }
        localStorage.setItem('workspace', this.selectedWorkspace);
        this.$vuetify.theme.themes.light = theme[this.selectedWorkspace];
        this.showDropdown = false;
      }
    }
  }
}
</script>

<style scoped>
.new-message-count {
  background-color: red;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
}

</style>
